import React from 'react';
import {Button, Dropdown, DropdownItem, Icon} from '@albert-io/atomic';

const sortByOptionMap = {
  updated_at: 'Recently Edited',
  name: 'Name'
};

interface SortDropdownProps {
  sortByOption: string;
  setSortByOption: (value: string) => void;
}

const SortDropdown = ({sortByOption, setSortByOption}: SortDropdownProps) => {
  return (
    <Dropdown
      trigger={
        <Button
          className='global-assignments__sort-by ml-x1'
          data-testid='sort-trigger'
          color='secondary'
          variant='outlined'
        >
          Sort by: {sortByOptionMap[sortByOption]}
          <Icon className='ml-x1' icon='caret-down' />
        </Button>
      }
      position='bottom-end'
      withMaxHeight
      closeOnItemClicked
    >
      <DropdownItem
        key='sort-updated_at'
        onClick={() => setSortByOption('updated_at')}
        withBottomBorder={false}
      >
        {sortByOptionMap.updated_at}
      </DropdownItem>
      <DropdownItem
        key='sort-name'
        onClick={() => setSortByOption('name')}
        withBottomBorder={false}
      >
        {sortByOptionMap.name}
      </DropdownItem>
    </Dropdown>
  );
};

export default SortDropdown;
